// Icon SVG lưới 24×24, họ Nét (UI_SPEC §7). Màu = currentColor; cỡ qua biến --ic của cha.
// Không emoji, không chữ Hán. Nguồn duy nhất của mọi icon.
import type { JSX } from 'preact';

const PATHS = {
  // 5 tab: 5 họ hình khác hẳn nhau.
  character: 'M12 3a4 4 0 1 1 0 8a4 4 0 1 1 0-8M4 21c1.2-4.2 4.3-6.5 8-6.5s6.8 2.3 8 6.5',
  world: 'M3 19l5.5-9l3.5 5l2.5-3.5L21 19zM16 5.5a1.5 1.5 0 1 0 0.01 0',
  destiny: 'M12 3c2.6 3 3.6 5.2 3.6 7.4a3.6 3.6 0 1 1-7.2 0C8.4 8.2 9.4 6 12 3M8 21h8M10 17.5h4v3.5h-4z',
  companions:
    'M8 4.5a3 3 0 1 1 0 6a3 3 0 1 1 0-6M16.5 6a2.5 2.5 0 1 1 0 5a2.5 2.5 0 1 1 0-5M3 20c.8-3.6 2.8-5.5 5-5.5s4.2 1.9 5 5.5M14 14.6c.8-.4 1.6-.6 2.5-.6c2 0 3.6 1.7 4.3 5',
  affairs: 'M3 9.5L12 4l9 5.5M5 9.5V19M19 9.5V19M9 19v-5h6v5M3 19.5h18',
  // Vỏ
  transmission: 'M4 12a8 8 0 0 1 16 0M7.5 12a4.5 4.5 0 0 1 9 0M12 12v8M9 20h6',
  bag: 'M7 8V6.5a5 5 0 0 1 10 0V8M4.5 8h15l-1.3 12h-12.4zM9.5 12.5h5',
  tasks: 'M6 3.5h9l3 3V20.5H6zM9 10h6M9 13.5h6M9 17h3.5',
  mail: 'M3 7l18-3l-4 16l-5-6l-5 3zM12 14l9-10',
  chevronLeft: 'M14.5 5.5L8 12l6.5 6.5',
  chevronRight: 'M9.5 5.5L16 12l-6.5 6.5',
  close: 'M6 6l12 12M18 6L6 18',
  // Tiền tệ
  spiritStone: 'M12 3l6.5 6l-6.5 12l-6.5-12zM5.5 9h13M9.5 9l2.5 12l2.5-12',
  summonTalisman: 'M7 3h10v18l-5-3l-5 3zM10 8h4M12 8v6M10 12.5h4',
  // Kênh Truyền Âm
  cultivation: 'M12 4v4M12 16v4M4 12h4M16 12h4M12 9a3 3 0 1 1 0 6a3 3 0 1 1 0-6',
  battle: 'M5 19L17 7M14.5 4.5l5 5M7 13l4 4M4 20l2-2',
  fate: 'M5 12c0-4 3-7 7-7s7 3 7 7M19 12c0 4-3 7-7 7s-7-3-7-7M12 9v6',
  system:
    'M12 8.5a3.5 3.5 0 1 1 0 7a3.5 3.5 0 1 1 0-7M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1',
  // Vật phẩm (glyph placeholder của ô, UI_SPEC §10.2)
  sword: 'M5 19L17 7l2-3-3 2L4 18M7 14l3 3M4 20l1.5-1.5',
  saber: 'M5 19c6-3 10-8 13-15c1 5-3 11-11 15M5 19l-1.5 1.5M8 15.5l1.8 1.8',
  helm: 'M5 15a7 7 0 0 1 14 0v3H5zM12 8V4M9 15h6',
  robe: 'M9 4h6l4 4-2 3-1-1v10H8V10l-1 1-2-3zM12 4v16',
  pants: 'M7 4h10l1 16h-4l-2-10-2 10H6z',
  gloves:
    'M8 20v-8L6 9V6.5a1 1 0 0 1 2 0V9V4.5a1 1 0 0 1 2 0V9V4a1 1 0 0 1 2 0v5V5a1 1 0 0 1 2 0v7l2-2a1.2 1.2 0 0 1 1.7 1.7L14 16v4z',
  boots: 'M8 4h5v9l6 3v4H7l1-8z',
  necklace: 'M5 4c0 6 3 10 7 10s7-4 7-10M12 14v2M9.5 18.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0',
  ring: 'M12 9a5.5 5.5 0 1 1 0 11a5.5 5.5 0 1 1 0-11M9.5 9L8 5.5h8L14.5 9',
  treasure: 'M12 3.5a8.5 8.5 0 1 1 0 17a8.5 8.5 0 1 1 0-17M12 8a4 4 0 1 1 0 8a4 4 0 1 1 0-8',
  charm: 'M8 3h8v18l-4-2.5L8 21zM10.5 8h3M12 8v6M10.5 11h3',
  pill: 'M12 5a7 7 0 1 1 0 14a7 7 0 1 1 0-14M8.5 9.5c1-1.2 2.2-1.8 3.5-1.8',
  herb: 'M12 21V10M12 13c-4 0-6-3-6-7c4 0 6 3 6 7M12 11c0-4 2-6 6-6c0 4-2 6-6 6',
  seed: 'M12 4c4 4 5 8 3 12a3.5 3.5 0 0 1-6 0C7 12 8 8 12 4M12 9v7',
  material: 'M4 9l8-5l8 5l-8 5zM4 9v6l8 5l8-5V9M12 14v6',
  lock: 'M7 11V8a5 5 0 0 1 10 0v3M5.5 11h13v9h-13zM12 14.5v2.5',
  chest: 'M4 10h16v10H4zM4 10l2-5h12l2 5M12 12.5v3M10 10v2.5h4V10',
  furnace: 'M6 20h12M8 20l-1-7h10l-1 7M9 13V9h6v4M10 9c0-2 1-3 2-5c1 2 2 3 2 5',
  garden:
    'M4 20h16M7 20v-5M12 20v-8M17 20v-5M7 15c-2 0-3-2-3-4c2 0 3 2 3 4M12 12c-2 0-3-3-3-6c2 1 3 3 3 6M17 15c2 0 3-2 3-4c-2 0-3 2-3 4',
  zone: 'M12 21s-7-6.5-7-11.5a7 7 0 0 1 14 0C19 14.5 12 21 12 21M12 7a2.5 2.5 0 1 1 0 5a2.5 2.5 0 1 1 0-5',
  dust: 'M6 16a2 2 0 1 0 .01 0M12 12a2.5 2.5 0 1 0 .01 0M17 16.5a1.8 1.8 0 1 0 .01 0M9 7.5a1.4 1.4 0 1 0 .01 0M16 8a1.2 1.2 0 1 0 .01 0',
  filter: 'M4 5h16l-6 8v6l-4 2v-8z',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, class: cls }: { name: IconName; class?: string }): JSX.Element {
  return (
    <svg class={cls ? `ic ${cls}` : 'ic'} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d={PATHS[name]} />
    </svg>
  );
}

export const ICON_NAMES = Object.keys(PATHS) as IconName[];
